<div class="px-2 py-2.5 lg:ml-4 inline-block lg:block">
  <a
    [link]="linkUrl"
    target="_blank"
    class="flex font-accent font-bold text-xl text-neutral-600"
    ><i class="icon icon-{{ item }}"></i
  ></a>
</div>
